import { Compass, Crosshair, Gem, Award } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import {
  ASSETS,
  MISSION,
  PROFILE,
  QUALITY_POLICY,
  REGISTRATIONS,
  VALUES,
  VISION,
} from "../data/content";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5">
          <SectionLabel>About Us</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[#0A192F]">
            Engineering assurance, delivered by people you can trust.
          </h2>
          <div className="relative mt-10 overflow-hidden rounded-sm">
            <img
              src={ASSETS.pipeline}
              alt="Engineers inspecting an industrial pipeline"
              className="h-64 w-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0A192F]/25" />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <p className="text-base md:text-lg leading-relaxed text-slate-600">{PROFILE}</p>

          <div className="mt-12 grid gap-8 sm:grid-cols-2">
            <div
              data-testid="mission-card"
              className="group border-l-2 border-[#0A192F] bg-slate-50 p-8 hover:border-[#D4AF37] transition-colors duration-300"
            >
              <Crosshair
                size={26}
                className="text-[#0A192F] group-hover:text-[#D4AF37] transition-colors duration-300"
              />
              <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-[0.16em] text-[#0A192F]">
                Mission
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{MISSION}</p>
            </div>
            <div
              data-testid="vision-card"
              className="group border-l-2 border-[#0A192F] bg-slate-50 p-8 hover:border-[#D4AF37] transition-colors duration-300"
            >
              <Compass
                size={26}
                className="text-[#0A192F] group-hover:text-[#D4AF37] transition-colors duration-300"
              />
              <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-[0.16em] text-[#0A192F]">
                Vision
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{VISION}</p>
            </div>
          </div>

          <div className="mt-8 grid gap-8 sm:grid-cols-2">
            <div className="border-l-2 border-slate-200 pl-6">
              <div className="flex items-center gap-2 text-[#0A192F]">
                <Gem size={16} className="text-[#D4AF37]" />
                <h4 className="font-display text-xs font-bold uppercase tracking-[0.2em]">
                  Quality Policy
                </h4>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{QUALITY_POLICY}</p>
            </div>
            <div className="border-l-2 border-slate-200 pl-6">
              <div className="flex items-center gap-2 text-[#0A192F]">
                <Award size={16} className="text-[#D4AF37]" />
                <h4 className="font-display text-xs font-bold uppercase tracking-[0.2em]">
                  Values
                </h4>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{VALUES}</p>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-2" data-testid="registrations">
            {REGISTRATIONS.map((r) => (
              <span
                key={r}
                className="rounded-full border border-slate-200 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500"
              >
                {r}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
